// extracted by mini-css-extract-plugin
export default {"root":"MaximizeButton_root__Xu66d","icon":"MaximizeButton_icon__K2CHz"};